import { LazyLoad } from 'features/common/ui/LazyLoad'
import { FeatureFlag, useFeatureFlag } from './useFeatureFlag'
import { lazy } from 'app/lazy'

const ErrorPage = lazy(() => import('features/errors/ui/ErrorPage'))

export default function RequireFeatureFlag({ flag, children }: { flag: FeatureFlag; children: React.ReactNode }) {
  const enabled = useFeatureFlag(flag)
  if (!enabled) {
    return (
      <LazyLoad>
        <ErrorPage code="404" />
      </LazyLoad>
    )
  }

  return <>{children}</>
}
